import Layout from '@/layout/Main.vue';
import { Lang } from '@/config';
import type { RouteRecordRaw } from 'vue-router';
// 静态路由
export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Layout,
    redirect: '/welcome',
    children: [
      {
        path: '/welcome',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: {
            [Lang.LAN_CN]: '首页',
            [Lang.LAN_TW]: '首頁',
            [Lang.LAN_EN]: 'Welcome',
            [Lang.LAN_RM]: 'Utama',
          },
          isExternalLink: false,
          isShowLink: true, //是否出现在导航栏
        },
      },
      {
        path: '/outstanding-cases',
        name: 'OutstandingCases',
        component: () => import('@/views/outstanding-case/index.vue'),
        meta: {
          title: {
            [Lang.LAN_CN]: '优秀案例',
            [Lang.LAN_TW]: '優秀案例',
            [Lang.LAN_EN]: 'Outstanding Case',
            [Lang.LAN_RM]: '​Contoh Cemerlang',
          },
          isExternalLink: false,
          isShowLink: false, //是否出现在导航栏
        },
      },
      {
        path: '/interactive-digital-human',
        name: 'InteractiveDigitalHuman',
        component: () => import('@/views/interactive-digital/index.vue'),
        meta: {
          title: {
            [Lang.LAN_CN]: '交互数字人',
            [Lang.LAN_TW]: '交互數字人',
            [Lang.LAN_EN]: 'Interactive Digital',
            [Lang.LAN_RM]: 'Agen Maya Interaktif',
          },
          isExternalLink: false,
          isShowLink: false, //是否出现在导航栏
        },
      },
    ],
  },
];
// 全屏的静态路由
export const remainingRoutes: Array<RouteRecordRaw> = [
  {
    path: '/ai-application-training',
    name: 'AiApplicationTraining',
    component: () => import('@/views/ai-application-training/index.vue'),
    meta: {
      title: {
        [Lang.LAN_CN]: 'AI应用实训',
        [Lang.LAN_TW]: 'AI應用實訓',
        [Lang.LAN_EN]: 'AI Application Training',
        [Lang.LAN_RM]: 'Latihan Aplikasi AI',
      },
      isExternalLink: false,
      isShowLink: false, //是否出现在导航栏
    },
  },
  {
    path: '/intelligent-live-streaming',
    name: 'IntelligentLiveStreaming',
    component: () => import('@/views/intelligent-live-streaming/index.vue'),
    meta: {
      title: {
        [Lang.LAN_CN]: '智能直播',
        [Lang.LAN_TW]: '智能直播',
        [Lang.LAN_EN]: 'Intelligent Live Streaming',
        [Lang.LAN_RM]: 'Siaran langsung pintar',
      },
      isExternalLink: false,
      isShowLink: false, //是否出现在导航栏
    },
  },
  {
    path: '/ai-teacher-class',
    name: 'AiTeacherClass',
    component: () => import('@/views/ai-teacher-class/index.vue'),
    meta: {
      title: {
        [Lang.LAN_CN]: 'AI讲师培训',
        [Lang.LAN_TW]: 'AI講師培訓',
        [Lang.LAN_EN]: 'AI Teacher Training',
        [Lang.LAN_RM]: 'Pengajaran Guru AI',
      },
      isExternalLink: false,
      isShowLink: false, //是否出现在导航栏
    },
  },
  {
    path: '/digital-human-oem',
    name: 'DigitalHumanOem',
    component: () => import('@/views/digital-human-oem/index.vue'),
    meta: {
      title: {
        [Lang.LAN_CN]: '数字人OEM',
        [Lang.LAN_TW]: '數位人OEM',
        [Lang.LAN_EN]: 'Digital Human OEM',
        [Lang.LAN_RM]: 'OEM Maya Digital',
      },
      isExternalLink: false,
      isShowLink: false, //是否出现在导航栏
    },
  },
];
export const constantCommonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    name: 'Error',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: {
        [Lang.LAN_CN]: '404',
        [Lang.LAN_TW]: '404',
        [Lang.LAN_RM]: '404',
        [Lang.LAN_EN]: '404',
      },
    },
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/agreement/index.vue'),
    meta: {
      title: {
        [Lang.LAN_CN]: '协议',
        [Lang.LAN_TW]: '協議',
        [Lang.LAN_RM]: 'Perjanjian',
        [Lang.LAN_EN]: 'Agreement',
      },
      isShowLink: false,
      rank: 103,
    },
  },
];
